// Upload file for athlete test
export const uploadAthleteTestVideo = async (
  apiInstance,
  athleteTestDetailId,
  userId,
  data,
  setUploadProgress,
) => {
  try {
    const response = await apiInstance.post(
      `/filesStorage/upload-athlete-video/${athleteTestDetailId}/${userId}`,
      data,
      {
        timeout: 10 * 60 * 1000,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "text/plain",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadProgress(percentCompleted);
        },
      },
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};
export const uploadProfilePhoto = async (apiInstance, formData) => {
  try {
    const response = await apiInstance.post(
      "/FilesStorage/upload-profile-photo",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const retrieveProfilePhotos = async (apiInstance) => {
  try {
    const response = await apiInstance.get(
      `/FilesStorage/retrieve-profile-photo/`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const deleteVideoById = async (apiInstance, videoId) => {
  try {
    const response = await apiInstance.delete(`/FilesStorage/video/${videoId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const uploadComparisonImageService = async (
  apiInstance,
  imageBase64,
  fileName,
) => {
  try {
    const { data } = await apiInstance.post(
      "/FilesStorage/image/upload-base64",
      {
        imageData: imageBase64,
        fileName,
      },
    );

    if (typeof data === "string" && data.startsWith("http")) {
      return data;
    }

    throw new Error("Backend did not return a valid image URL");
  } catch (error) {
    console.error("Error uploading comparison image:", error);
    throw error;
  }
};

export const sendEmailService = async ({
  apiInstance,
  toEmails,
  imageUrl,
  content,
  subject,
  shareType = 0,
}) => {
  try {
    const response = await apiInstance.post("/Share/send/email", {
      toEmails,
      imageUrl,
      content,
      subject,
      shareType,
    });

    return response.data;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error.response ? error.response.data : new Error("An error occurred");
  }
};
